//External
import CommonInfoModal from "components/modals/commonInfoModal";
import React, { useState } from "react";
import { TOOLTIP_MESSAGE } from "utils";
import tooltip from "../../public/assets/images/tooltip.svg";
import ManualTooltip from "components/mannualTooltip";

/*******************
  @Purpose : used for offer card
  @Parameter : { vehicalDetailData }}
  @Author : INIC
  *******************/
const OfferCard = ({ isMobileScreen }) => {
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [modalName, setModalName] = useState("");
  const handleInfoClose = () => setShowInfoModal(false);
  const handleInfoShow = (name) => {
    setShowInfoModal(true);
    setModalName(name);
  };
  /*******************
   @Purpose : tooltip
   @Parameter : {}
   @Author : INIC
 *******************/
  const renderTooltip = () =>
    modalName === "Weekly Discount" ? (
      <span className="d-flex mb-2">
        {TOOLTIP_MESSAGE.OFFER_CARD_DISCOUNT_1}
      </span>
    ) : (
      <span className="d-flex mb-2">
        {TOOLTIP_MESSAGE.OFFER_CARD_DISCOUNT_2}
      </span>
    );

  /*******************
  @purpose : Rander HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <>
      <div className="d-flex flex-column offer-list">
        <div className="d-flex align-items-center offer-card">
          <span className="icon icon-discount1"></span>
          <ul className="mb-0 offer-content list-unstyled">
            <li className="d-flex align-items-center">
              <span className="dot"></span>
              <span className="text">15% Weekly Discount</span>
              {isMobileScreen && (
                <div className="tooltip-wrapper">
                <img
                  src={tooltip}
                  alt="Tooltip"
                  onClick={() => handleInfoShow("Weekly Discount")}
                />
                </div>
              )}
              {!isMobileScreen && (
                <ManualTooltip
                  content={
                    <div className="tooltip-modal">
                      <div className="weekly-block common-modal-tooltip">
                        <div className="breakdown-modal flex-column">
                          <div className="modal-header common-tooltip-header w-100">
                            <h3 className="modal-title tooltip-title">
                              Weekly Discount
                            </h3>
                          </div>
                          <div className="common-seprarte tootltip-seprate w-100">
                            <div>
                              <span className="d-flex mb-2">
                                {TOOLTIP_MESSAGE.OFFER_CARD_DISCOUNT_1}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  trigger="hover"
                >
                  <img
                    src={tooltip}
                    alt="Tooltip"
                    style={{ cursor: "pointer" }}
                  />
                </ManualTooltip>
              )}
            </li>

            <li className="d-flex align-items-center">
              <span className="dot"></span>
              <span className="text">30% Monthly Discount</span>
              {isMobileScreen && (
                <div className="tooltip-wrapper">
                <img
                  src={tooltip}
                  alt="Tooltip"
                  onClick={() => handleInfoShow("Monthly Discount")}
                />
                </div>
              )}
              {!isMobileScreen && (
                <ManualTooltip
                  content={
                    <div className="tooltip-modal">
                      <div className="monthly-block common-modal-tooltip">
                        <div className="breakdown-modal flex-column">
                          <div className="modal-header common-tooltip-header w-100">
                            <h3 className="modal-title tooltip-title">
                              Monthly Discount
                            </h3>
                          </div>
                          <div className="common-seprarte tootltip-seprate w-100">
                            <div>
                              <span className="d-flex mb-2">
                                {TOOLTIP_MESSAGE.OFFER_CARD_DISCOUNT_2}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  trigger="hover"
                >
                  <img
                    src={tooltip}
                    alt="Tooltip"
                    style={{ cursor: "pointer" }}
                  />
                </ManualTooltip>
              )}
            </li>
          </ul>
        </div>
      </div>
      <CommonInfoModal
        showModal={showInfoModal}
        handleClose={handleInfoClose}
        infoDetails={renderTooltip()}
        title={modalName}
      />
    </>
  );
};
export default OfferCard;
